export default __webpack_public_path__ + "static/5.cb5dcfadca1473c42a70359a8e822e14.png";